// import _ from 'underscore';
import $ from 'jquery';

class SponsoredContentAutoScroll {
    playerPosition(playerEl) {
        let bodyRect = document.body.getBoundingClientRect();
        let playerRect = playerEl.getBoundingClientRect();
        return (playerRect.top - bodyRect.top);
    }

    scrollPosition() {
        const doc = document.documentElement;
        return {
            'left': (window.pageXOffset || doc.scrollLeft) - (doc.clientLeft || 0),
            'top': (window.pageYOffset || doc.scrollTop)  - (doc.clientTop || 0)
        };
    }

    playerInView() {
        let i = 0;
        let posterVideos = document.querySelectorAll('.fc-header iframe');
        let data = {};
        let difference;
        let adjust;
        let inView;

        for (i; i < posterVideos.length; i++) {
            difference = this.playerPosition(posterVideos[i]) - this.scrollPosition().top;
            adjust = window.innerHeight > ($(posterVideos[i]).height() / 2) ? window.innerHeight : 100;
            inView = (difference > -100 && difference < adjust);

            data.command = 'pause';

            if (inView) {
                data.command = 'playinview';
            }

            posterVideos[i].contentWindow.postMessage(data, '*');
        }
    }

    on() {
        window.setInterval(function () {
            this.playerInView();
        }.bind(this), 500);
    }
}

export default new SponsoredContentAutoScroll();
